import React, { memo } from 'react'
import RefreshTwoToneIcon from '@mui/icons-material/RefreshTwoTone'
import Button from '../../../components/Button'

const GlobalReset = () => {
  return (
    <Button
      variant="topNav"
      className="button topNav__button -reload"
      onClick={() => window.location.reload()}
    >
      <RefreshTwoToneIcon className="material-icons-two-tone" />
      <span className="button__text">Reset</span>
    </Button>
  )
}

export default memo(GlobalReset)
